import React, { useState, useEffect } from 'react';
import { Popover } from '@headlessui/react';
import { CheckCircle, XCircle } from 'lucide-react';

export const PasswordGuidePopover = ({ password, children, onValidate }) => {
  const [validations, setValidations] = useState({
    hasLength: false,
    hasNumber: false,
    hasSpecial: false,
    hasUpper: false,
    hasLower: false
  });

  useEffect(() => {
    const newValidations = {
      hasLength: password.length >= 8,
      hasNumber: /\d/.test(password),
      hasSpecial: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      hasUpper: /[A-Z]/.test(password),
      hasLower: /[a-z]/.test(password)
    };
    
    setValidations(newValidations);
    
    // Check if all validations pass
    const isValid = Object.values(newValidations).every(Boolean);
    if (onValidate) {
      onValidate(isValid);
    }
  }, [password, onValidate]);

  const ValidationItem = ({ satisfied, text }) => (
    <div className="flex items-center gap-2">
      {satisfied ? (
        <CheckCircle className="h-4 w-4 text-green-500" />
      ) : (
        <XCircle className="h-4 w-4 text-red-500" />
      )}
      <span className={`text-sm ${satisfied ? "text-green-700" : "text-gray-600"}`}>
        {text}
      </span>
    </div>
  );

  return (
    <Popover className="relative w-full">
      {({ open }) => (
        <>
          <Popover.Button as="div" className="w-full focus:outline-none">
            {children}
          </Popover.Button>

          {open && (
            <div className="absolute z-10 w-72 right-full top-0 -translate-x-2">
              <div className="bg-white border border-gray-200 rounded-md shadow-lg p-4">
                <div className="space-y-2">
                  <ValidationItem 
                    satisfied={validations.hasLength} 
                    text="At least 8 characters" 
                  />
                  <ValidationItem 
                    satisfied={validations.hasNumber} 
                    text="Contains a number" 
                  />
                  <ValidationItem 
                    satisfied={validations.hasSpecial} 
                    text="Contains a special character" 
                  />
                  <ValidationItem 
                    satisfied={validations.hasUpper} 
                    text="Contains uppercase letter" 
                  />
                  <ValidationItem 
                    satisfied={validations.hasLower} 
                    text="Contains lowercase letter" 
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </Popover>
  );
};